import React from "react";
import { PageModule } from "@/components/PageModule";
import {
  UserTestimonial,
  UserTestimonials,
} from "@/features/testimonials/UserTestimonials";

export interface UserTestimonialModule {
  testimonials: UserTestimonial[];
}
export const UserTestimonialModule = ({
  testimonials,
}: UserTestimonialModule) => {
  const quotedTestimonials = testimonials.map((t) => ({
    ...t,
    quote: `“${t.quote}”`,
  }));
  return (
    <PageModule className="md:px-0 lg:py-12">
      <UserTestimonials testimonials={quotedTestimonials} />
    </PageModule>
  );
};
